import { render, staticRenderFns } from "./selectPermissions.vue?vue&type=template&id=a9194c7c&"
import script from "./selectPermissions.vue?vue&type=script&lang=js&"
export * from "./selectPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/other/selectPermissions/selectPermissions.vue"
export default component.exports